<!--
  作者：xiaoyu.li
  时间：2020年03月14日 14:49:09
-->
<template>
  <div>
    <div class="coupon_gradient" v-if="coupons.length">
      <div class="detail_coupon">
        <div class="coupon_title flex-center">
          <img
            style="width:20px;height: 20px;margin-right: 4px;"
            src="https://img.esenyun.com/images/20200526/74b2916760114c8da8e83a24e7126899.png"
          />领券专区
        </div>
        <div
          class="ticket"
          v-for="item in coupons"
          :key="item.couponId"
          @click="showPopup(item)"
        >
          <CouponType :info="item"></CouponType>
        </div>
      </div>
    </div>
    <!-- <van-popup
      :show="showTicket"
      catchtouchmove="true"
      :round="true"
      @close="showTicket = false"
      close-icon="https://img.esenyun.com/images/20200315/db880a048c6e4985840f2f0e0b0698bc.png"
      closeable
    >
      <GetCoupon :activityId="activityId" :info="currentCoupon" @hide="hidePopup"></GetCoupon>
    </van-popup> -->
  </div>
</template>

<script>
import CouponType from './CouponType'
export default {
  // 组件名称
  name: 'DetailCoupon',
  // 组件参数 接收来自父组件的数据
  props: {
    activityId: {
      type: String,
      default: '',
    },
    shareId: {
      type: String,
      default: '',
    },
  },
  // 局部注册的组件
  components: {
    CouponType,
  },
  // 组件状态值
  data() {
    return {
      showTicket: false, // 领券弹出框
      coupons: [], // 活动券列表
      currentCoupon: {}, // 弹框中卡券详情
    }
  },
  // 计算属性
  computed: {},
  mounted() {
    this.getCoupons()
  },
  // 组件方法
  methods: {
    // 活动券列表
    getCoupons() {
      console.log(111111)
      this.$http
        .get(`aocampaign/openapi/activity/coupon/list/${this.activityId}`)
        .then((res) => {
          this.coupons = res.data
          console.log('%c 详情页卡券列表', 'color:green', this.coupons)
        })
    },
    // 打开立即领取弹框
    showPopup(item) {
      this.$router.push(
        `couponDetail?id=${item.couponId}&shareId=${this.shareId}`
      )
    },
    // 关闭立即领取弹框
    hidePopup() {
      this.showTicket = false
    },
  },
}
</script>

<style lang="less" scoped>
.coupon_gradient {
  background: linear-gradient(
    180.41deg,
    #fe6d2c 14.53%,
    #ffc77c 77.67%,
    #ffb455 100%
  );
}
.detail_coupon {
  background: url('https://img.esenyun.com/images/20200317/dcbcf11d22ce4606819255412f24b3dd.png')
    no-repeat 100% auto;
  padding: 12px 16px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  .coupon_title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    margin-bottom: 12px;
    .label {
      background: #f9e14c;
      display: inline-block;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      margin-right: 4px;
      border-radius: 2px;
      color: #fd533e;
      font-weight: normal;
      vertical-align: middle;
      margin-top: -3px;
    }
  }
}
.ticket {
  margin-bottom: 8px;
}
/deep/.van-popup {
  border-radius: 8px;
}
</style>
